import { readCookie } from "./Cookies";

const getSegmentAndGaFromCookies = () => {
    const segment = JSON.parse(readCookie('controlGroupV3'))?.GrupoControlMeteredV3;
    const ga = readCookie('_ga')

    return {segment, ga}
}

export default getSegmentAndGaFromCookies;